var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentData)?_c('cart-card',_vm._b({},'cart-card',_vm.componentData,false),[_c('div',{staticClass:"my-4 text-center"},[_vm._v(" 48 Hours of video with "),_c('span',{staticClass:"pink--text"},[_vm._v("Full Access")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }